<template>
  <div id="Tec" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 bg-color-white pl5 pr5 fixed-t b-s-2">
      <div class="col-12 lh40 bg-color-white pl5 pr5">
          <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-muted"></i></div>
          <div class="col-6 t-c color-white">-</div>
          <div class="col-3 t-r f26"><i class="iconfont icon-gengduo color-muted"></i></div>
      </div>
      
      <div class="col-12 bg-color-white pl20 pr20 pb20">
        <div class="col-12 t-c">
          <img src="../../assets/user.png" alt="" class="w10 r50">
        </div>
        <div class="col-12 t-c pt10 fw f18 uppercase el1">
         <span class="color-muted fw100" v-if="$store.state.account.account_grade == 99">{{ pageData.aid }}</span> {{ pageData.name }} <span class="bg-color-warning color-white f12 pt1 pb1 pl3 pr3 r5">L.{{pageData.account_grade}}</span>
        </div>
      </div>
    </div>
    <div class="h20"></div>
    <div class="col-12 pt5 pb5">
      <div class="col-12 bg-color-white">
        <div class="col-4 pr5 pt8 pb8">
          <div class="col-12 bg-color-white t-c r5 br1">
            <div class="col-12 f28 color-primary">{{pageData.account_points}}</div>
            <div class="col-12 f14 color-muted">Puntos</div>
          </div>
        </div>
        <div class="col-4 pl5 pr5 pt8 pb8" @click="unlock_points()">
          <div class="col-12 bg-color-white t-c r5 br1">
            <div class="col-12 f28 color-primary">{{pageData.lock_points}}</div>
            <div class="col-12 f14 color-muted">Bloqueado</div>
          </div>
        </div>
        <div class="col-4 pl5 pt8 pb8">
          <div class="col-12 bg-color-white t-c r5">
            <div class="col-12 f28 color-primary">{{pageData.account_credit}}</div>
            <div class="col-12 f14 color-muted">Crédito</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt5 t-c">
      <div class="col-12 bg-color-white pl10 pr10 lh50" @click="go_funds()">
        <div class="col-2 f30 t-l color-primary">
          <i class="iconfont icon-cunkuan"></i>
        </div>
        <div class="col-10 bb1">
          <div class="col-6 t-l ">Fondos</div>
          <div class="col-6 t-r"><i class="iconfont icon-31fanhui2 color-muted"></i></div>
        </div>
      </div>
      <div class="col-12 bg-color-white pl10 pr10 lh50">
        <div class="col-2 f30 t-l color-primary">
          <i class="iconfont icon-31haoyou"></i>
        </div>
        <div class="col-10 bb1">
          <div class="col-6 t-l ">Clientes</div>
          <div class="col-6 t-r"><span class="mr10 fw">{{ pageData.client_count }}</span><i class="iconfont icon-31fanhui2 color-muted"></i></div>
        </div>
      </div>
      <div class="col-12 bg-color-white pl10 pr10 lh50" @click="go_report()">
        <div class="col-2 f30 t-l color-primary">
          <i class="iconfont icon-fl-baobiao"></i>
        </div>
        <div class="col-10 bb1">
          <div class="col-6 t-l ">Report</div>
          <div class="col-6 t-r"><i class="iconfont icon-31fanhui2 color-muted"></i></div>
        </div>
      </div>
    </div>
    <div ref="app_foot" class="col-12 fixed-b color-white f14 bg-color1 lh50 h5 uppercase" v-if="pageData.tec_name == $store.state.account.user">
      <div class="col-6 bg-color-success t-c f12" @click="go_act(1)"><i class="iconfont icon-diannao color-white f22"></i> Agregar CAJA</div>
      <div class="col-6 bg-color-primary t-c f12" @click="go_act(2)"><i class="iconfont icon-jinrudianpu color-white f22"></i> agregar sucursal</div>
    </div>
    <div ref="app_foot" class="col-12 fixed-b color-white f14 bg-color1 lh50 h5 uppercase" v-else-if="pageData.tec_id == 0">
      <div class="col-12 bg-color-warning t-c f12" v-if="pageData.log_find == 1"><i class="iconfont icon-shalou color-white f22"></i> La solicitud se está procesando</div>
      <div class="col-12 bg-color-warning t-c f12" @click="get_it_confim()" v-else><i class="iconfont icon-31wode color-white f22"></i> Este es mi cliente</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Tec',
  data () {
    return {
      aid: '',
      pageData: {},
      extension_list: []
    }
  },
  created: function () {
    this.aid = this.$route.query.aid
    this.get_pageData();
  },
  methods: {
    get_pageData() {
      var post_data = {}
      post_data.aid = this.aid
      this.post(this.api_url + 'Agent/tec',post_data,true).then((res)=>{
        if(res.status == 1){
          this.pageData = res.data;
          //this.get_dist();
          //console.log(this.$store.state.account.user)
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    go_funds(){
      this.$router.push({name:'A_Funds',query:{aid: this.aid}});
    },
    go_clients_list(tec_id){
      this.$router.push({name:'A_ClientsList',params:{tec_id: tec_id}});
    },
    get_extension(){
      var post_data = {}
      post_data.pos_id = this.pos_id
      this.post(this.api_url + 'Agent/extensions',post_data,true).then((res)=>{
        if(res.status == 1){
          this.extension_list = res.data;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    //解锁积分
    unlock_points(){
      var post_data = {}
      post_data.aid = this.aid
      this.post(this.api_url + 'Agent/unlock_points',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.get_pageData();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    go_act(act_type){
      this.$router.push({name:'Activation',params:{rif: this.pageData.license_type + this.pageData.license, act_type: act_type, store:this.pageData.store}});
    },
    go_ext(id){
      this.$router.push({name:'T_Extension',params:{id: id}});
    },
    go_report(){
      this.$router.push({name:'A_Report',query:{aid: this.aid}});
    },
    get_it_confim(){
      this.$store.commit('setConfimBox',{type:'confim_exit',msg:'Revisaremos su solicitud y le notificaremos más tarde.',_this:this,focus:'',method:'get_it',arg1:''});
    },
  },
  mounted() {
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Agent/Tec.vue